export const resyJSONKeys = [
  'all_card_product_order_desktop',
  'all_card_product_order_mobile',
  'icon_mappings',
  'additional_products',
  'api_products',
];

export const resyProductJSONKeys = [
  'product_name',
  'product_code',
  'apr_symbol',
  'apr_name',
  'apr_pay_over_time_text',
  'rate_and_fees_aria_label',
  'rate_and_fees_track',
  'offer_benefit_terms_aria_label',
  'offer_benefit_terms_track',
  'apply_now_aria_label',
  'apply_now_track',
  'image_alt',
  'annual_fee_symbol',
  'card_cta_campaign_link',
  'rate_and_fees_symbol',
  'offer_benefit_terms_symbol',
  'rate_and_fees_label',
  'offer_benefit_terms_label',
  'apply_link_label',
  'annual_fee_label',
  'benefits_title',
  'show_more_label',
  'show_less_label',
  'hide_link_label',
];

export default resyJSONKeys;
